import FlagSwitcher from './FlagSwitcher';
import FlagSwitcherContainer from './FlagSwitcher.container';
export default FlagSwitcherContainer(FlagSwitcher);
